<template>
  <div class="login">
    <div class="login-container">
      <img src="@/assets/ats-logo.png" alt="Logo" class="logo" />
      <div v-if="$auth.loading">Loading Auth...</div>
      <div v-else>
        <button class="btn btn-fill btn-info" @click="login">Log In</button>
      </div>
      <div style="margin-top: 20px;">Stuck in a login loop? <a href="#" @click="clearCookiesAndLocalStorage">Click here</a> to clear your cache.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Login',
  methods: {
    login() {
      this.$auth.loginWithRedirect()
    },
    clearCookiesAndLocalStorage() {
      localStorage.clear()
      this.deleteAllCookies()
      this.$auth && this.$auth.logout()
    },
    deleteAllCookies() {
      // Get all cookies as a string
      const cookies = document.cookie.split(";")

      // Loop through each cookie
      cookies.forEach(cookie => {
        // Extract the cookie name (part before the '=')
        const eqPos = cookie.indexOf("=")
        const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim()

        // Delete the cookie by setting it to expire in the past
        // Try multiple domain and path combinations to ensure deletion
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${window.location.hostname}`
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${window.location.hostname}`
      })
    }
  },
  mounted() {
    if (this.$auth.isAuthenticated) {
      this.$router.push('/projects/search')
    }
  }
}
</script>
<style scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 80vh;
}

.login-container {
  text-align: center;
}

.logo {
  width: 150px;
  margin-bottom: 20px;
}

button {
  transition: background-color 0.3s ease;
  background-color: #036D4B;
  color: white;
  padding: 12px 24px;
  border: none;
  font-size: 16px;
  cursor: pointer;
}

.login-container >>> .btn:hover {
  background-color: #048A5C;
}
</style>
